/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { SearchSurveyLabelGeometryDto } from '../../models/search-survey-label-geometry-dto';

export interface SearchForSurveyLabelGeometryByPfiList$Params {
  survey_label: string;

  /**
   * Comma-separated list of PFI values (e.g. 123 or 123,234,345)
   */
  pfi: Array<string>;
}

export function searchForSurveyLabelGeometryByPfiList(
  http: HttpClient,
  rootUrl: string,
  params: SearchForSurveyLabelGeometryByPfiList$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SearchSurveyLabelGeometryDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    searchForSurveyLabelGeometryByPfiList.PATH,
    'get',
  );
  if (params) {
    rb.query('survey_label', params.survey_label, {});
    rb.query('pfi', params.pfi, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SearchSurveyLabelGeometryDto>;
      }),
    );
}

searchForSurveyLabelGeometryByPfiList.PATH = '/search/survey-label/geometry';
